export const BlockUserActionTypes = {
    ADD_BLOCKUSER : 'ADD_BLOCKUSER',
    ADD_BUTTON: 'ADD_BUTTON'
};